export enum NameCurrentProcessWiService{
    ProcessStart,
    FetchFromGit,
    StopService,
    PublishToDirectory,
    StartService
}